<template>
    <b-input-group>
        <b-form-textarea v-model="link"
                         type="text"
                         ref="input"
                         id="input"
                         class="no-background"
                         readonly
                         @focus.native="$event.target.select()"
                         placeholder="your link">
        </b-form-textarea>
        <b-input-group-append>
            <b-btn variant="success" @click.prevent="copyLink()">{{copied? 'Copied': 'Copy' }}</b-btn>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
    export default {
        props: ['link', 'copied'],
        data() {
            return {}
        },
        methods: {
            copyLink() {
                let input = this.$refs.input.$el;
                input.select();
                this.$emit('copyLink')
            },
        },
    }
</script>

<style scoped>
    .form-control:disabled, .form-control[readonly] {
        background-color: #ffffff;
        opacity: 1;
    }
</style>

